import Tracking from './tracking-view';
import React from 'react';
import { Outlet, useLocation } from 'react-router';

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  React.useEffect(() => {
    if (typeof window !== 'undefined' && !hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, [pathname, hash]);

  return (
    <>
      <Tracking />
      <Outlet />
    </>
  );
};
